$(document).ready(function() {
  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .parent().find('.file-name')
        .text($(this)[0].files[0].name);

      $(this)
        .parent().find('.form-field')
        .removeClass('border-dark-silver');

      $(this)
        .parent().find('.form-field')
        .addClass('border-dark');

      $(this)
        .parent(1).find('.form-field-container')
        .removeClass('border-dark-silver');

      $(this)
        .parent(1).find('.form-field-container')
        .addClass('border-dark');
    }
  });
})
